import { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const Captcha2 = ({ onVerify }) => {
  const handleRecaptchaVerify = (token) => {
    if (token) {
      // v2 reCAPTCHA - just verify it was completed
      onVerify(true);
    } else {
      onVerify(false);
    }
  };

  return (
    <ReCAPTCHA
      sitekey={process.env.REACT_APP_RECAPTCHA_SECRET_KEY}
      onChange={handleRecaptchaVerify}
    />
  );
};

export default Captcha2;
